import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
    phone: Yup.string().required().label('موبایل'),
    password: Yup.string().min(8).required().label('رمز عبور'),
});